import {inlineError} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import UserNotLoggedInUserError from '../Errors/UserNotLoggedInUserError.js'

/**
 * @implements UseCase
 */
export class GetConsentsUserUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Service} deps.service
   * @param {Repository} deps.httpUserRepository
   * @param {Repository} deps.sessionStorageUserRepository
   */
  constructor({config, getCurrentUserService, httpUserRepository, sessionStorageUserRepository}) {
    super()

    this._config = config
    this._getCurrentUserService = getCurrentUserService
    this._httpUserRepository = httpUserRepository
    this._sessionStorageUserRepository = sessionStorageUserRepository

    const {USER_CONSENTS} = this._config.get('user')
    this._userConsentsKey = USER_CONSENTS.FINANCIAL_SERVICES
  }

  /**
   * @return {Array<Object, Error>} returns consents status of current user
   * @property {Object} user
   */
  @inlineError
  async execute() {
    const userEntity = await this._getCurrentUserService.execute()

    const [error, response] = await this._httpUserRepository.getConsents({
      userEntity
    })

    const [errorSessionStorage, responseSessionStorage] = await this._sessionStorageUserRepository.getConsentsStatus()

    if (error instanceof UserNotLoggedInUserError) {
      if (errorSessionStorage) Promise.reject(errorSessionStorage)

      return responseSessionStorage
    }

    if (error) throw error

    const consentValue = response.getConsentStatus({
      key: this._userConsentsKey
    })

    const consentValueOnStorage = responseSessionStorage.getConsentStatus({
      key: this._userConsentsKey
    })

    if (!consentValue && consentValueOnStorage) {
      response.setConsentStatus({
        key: this._userConsentsKey,
        status: consentValueOnStorage
      })

      await this._httpUserRepository.updateConsents({
        userConsentsStatusUserValueObject: response,
        userEntity
      })

      return response
    }

    return response
  }
}
